// extracted by mini-css-extract-plugin
export default {"avatar":"UserAvatar_avatar__EA3A5","photo":"UserAvatar_photo__9tbT3","wypelnij":"UserAvatar_wypelnij__aTEb7"};